export default {
  title: 'Instrumente de sprijin pentru luarea deciziilor',
  description: 'Estimator24 ajută cumpărătorii, investitorii și agențiile să ia decizii bine fundamentate pe baza datelor și a inteligenței artificiale.',
  features: {
    evaluation: 'Evaluarea proprietății dintr-un singur clic',
    forecast: 'Prognoze de prețuri cu ajutorul rețelelor neuronale',
    analytics: 'Analiza pieței pe regiuni și cartiere',
    tools: 'Instrumente de comparare și filtrare'
  }
}
